import { secureApiPost } from '../secureHttp';
import type { ScheduleType } from './list';

export type PsychologistWorkScheduleCreateInput = {
  weekday: number;
  start_time: string;
  end_time: string;
  active?: boolean;
  appointment_types?: string[];
  schedule_type?: ScheduleType;
};

export async function createPsychologistWorkSchedule(data: PsychologistWorkScheduleCreateInput) {
  return await secureApiPost(`/v1/psi-platform/psychologist/calendar/work-schedules`, data);
}


